import React, { useRef, useState } from 'react'
import classes from './signature.module.scss'
import { DoctorService } from '../../api/DoctorService'
import SignatureHandler from "../../helpers/SignHandler";

const Signature = ({onSign, id, signed }) => {

  const [show, setShow] = useState(false)

  const iframeRef = useRef(null);

  const showResult = async(id) => {
        await DoctorService.getDoctorPdf(id).then(res=>{
            if (res?.data){
                const iframe = iframeRef.current;
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                iframeDoc.open();
                iframeDoc.write(res?.data);
                iframeDoc.close();
            }
        })
  }
  

  if(id && !show){
    showResult(id)
  }

  const closeButton = () => {
    onSign(false)
  }

  const confirmData = () =>{
    setShow(true)
  }

  const finishRound = (id) =>{
    onSign(false)
    setShow(false)
    signed(true)
  }

  return (
    <div className={classes.container}>
        <button onClick={closeButton} className={classes.closeButton}>
            X
        </button>
        {!show && <iframe className={classes.box} ref={iframeRef} title='Before sign'/>}
        {!show && <button className={classes.button} onClick={confirmData}>Підписати</button>}
        {show && <SignatureHandler signed={finishRound} clientId={id}/>}
    </div>
  )
}

export default Signature